export default __webpack_public_path__ + "static/char-s-47-ja-d616d84ffbb0502f8e0942a5a26fdd7a.webp";